import { useNavigate } from "react-router-dom";
import '../../Pages/Pricing/Pricing.css'
import { useEffect } from "react";
import { TextService } from "../../Services/TextService";

const PageSmall = (props: any) => {
    const cssClass = "Page PageSmall " + props.className;
    useEffect(() => {
        document.title = props.pageTitle ?? TextService.GetText("Common_PageTitle");
    }, []);

    return <div className={cssClass}>
        {props.children}
    </div>
};

export default PageSmall;